import React from 'react';
import { Button, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CUSTOM_BUTTON_OPTIONS, sizeMap } from '../../../constants/optionsConfig';

const CustomButton = ({
  isFullWidthMobile = false,
  areaLabel = '',
  className,
  onClick = () => { },
  category = 'primary',
  size = CUSTOM_BUTTON_OPTIONS.S1,
  children,
  varient = "contained",
  borderRadius = 0,
  fontWeight = "500",
  isLoading = false,
  enableTextOverflow = false
}) => {

  const theme = useTheme();
  const buttonStyle = sizeMap[size];
  const buttonColor = theme.palette[category]?.main || theme.palette.customColor.white;

  return (
    <Button
      loading={isLoading}
      aria-label={areaLabel}
      onClick={onClick}
      variant={varient} // outlined || contained || text
      className={`common-button ${className}`}
      sx={{
        width: { sm: buttonStyle.width, xs: isFullWidthMobile ? '100%' : buttonStyle.width },
        minHeight: { md: buttonStyle.height, xs: isFullWidthMobile ? '32px' : buttonStyle.height },
        fontSize: buttonStyle.font,
        fontWeight: fontWeight,
        lineHeight: buttonStyle.lineHeight,
        borderRadius: borderRadius,
        backgroundColor: buttonColor,
        color: buttonColor === theme.palette.customColor.white ? theme.palette.primary.main : theme.palette.customColor.white,
        '&:hover': {
          backgroundColor: category === 'primary'
            ? theme.palette.primary.light
            : category === 'secondary'
              ? theme.palette.secondary.dark
              : category === 'tertiary'
                ? theme.palette.tertiary.light
                : `rgba(252, 252, 252, 0.88)`
        },
        textTransform: 'none'
      }}
    >
      {enableTextOverflow ? (
        <Box sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: "auto",
          maxWidth: "199px",
          padding: '0 4px',
          boxSizing: 'border-box',
        }}>
          {children}
        </Box>
      ) : (
        children
      )}
    </Button>
  );
};

export default CustomButton;
